module.exports = __webpack_public_path__ + "assets/images/assessment-classification.a7cb4ea9e35ebdb8bd354412d55294fa.svg";